var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDokument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Dokument__Icn/40px/Dokument",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Dokument__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Dokument__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.5,4 C26.9852814,4 29,6.01471863 29,8.5 C29,10.9852814 26.9852814,13 24.5,13 C24.3004192,13 24.1038729,12.9870073 23.911161,12.9618214 L23.323,14 L28,14 C28.5128358,14 28.9355072,14.3860402 28.9932723,14.8833789 L29,15 L29,30 C29,30.5522847 28.5522847,31 28,31 L12,31 C11.4477153,31 11,30.5522847 11,30 L11,15 C11,14.4477153 11.4477153,14 12,14 L20.935,14 L21.6418106,11.9759041 C20.6392667,11.1505712 20,9.89993995 20,8.5 C20,6.01471863 22.0147186,4 24.5,4 Z M20.236,16 L13,16 L13,29 L27,29 L27,16 L22.193,16 L21.0674998,17.9917603 L19.5477295,17.9744542 L20.236,16 Z M21,24 L21,26 L16,26 L16,24 L21,24 Z M24,20 L24,22 L16,22 L16,20 L24,20 Z M24.5,6 C23.1192881,6 22,7.11928813 22,8.5 C22,9.88071187 23.1192881,11 24.5,11 C25.8807119,11 27,9.88071187 27,8.5 C27,7.11928813 25.8807119,6 24.5,6 Z",
    id: ".._.._src_svg_Icn_40px_Dokument__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDokument);
export default __webpack_public_path__ + "static/media/Dokument.d070714b010427c24fd368ff36135e79.svg";
export { ForwardRef as ReactComponent };